// extracted by css-extract-rspack-plugin
export default {"cls1":"EdgePill-cls1_9pq","cls2":"EdgePill-cls2_AEX EdgePill-cls1_9pq","dock-enter":"EdgePill-dock-enter_rcs","footerOffset":"EdgePill-footerOffset_oWc"};